import React from "react";
import Spinner from "./spinner";

export interface BusyButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** While true the button shows a spinner + in-progress label and ignores clicks. */
  busy?: boolean;
  /** Shown instead of `label` while busy (defaults to "Saving…"). */
  busyLabel?: string;
  /** Base button class, e.g. "jf-btn jf-btn-primary". */
  variant?: string;
  label: React.ReactNode;
}

/**
 * Button with a built-in saving/loading state: shows a spinner and swaps the
 * label while an async action is in flight.
 */
export default function BusyButton({
  busy = false,
  busyLabel,
  variant = "jf-btn",
  label,
  className = "",
  disabled,
  onClick,
  ...rest
}: BusyButtonProps) {
  const classes = [
    variant,
    busy ? "jf-btn--busy" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type="button"
      className={classes}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      onClick={busy ? undefined : onClick}
      {...rest}
    >
      {busy ? (
        <>
          <Spinner size={14} />
          <span>{busyLabel ?? "Saving…"}</span>
        </>
      ) : (
        label
      )}
    </button>
  );
}
